import { defineMessages } from 'react-intl';

export const messages: {
	filterSpotlightMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dismissButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	nextButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	moreActionsSpotlightMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	okButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	listMergeSpotlightHeading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	listMergeSpotlightBody: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	exploreListViewButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	listMergeSpotlightDismiss: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	listMergeSpotlightTellMeMoreAriaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	heading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	description: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	learnMoreLink: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	closeButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	filtersAndGroupsDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	copyListSettingsYes: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	copyListSettingsNo: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	copyListSettingsDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	filterSpotlightMessage: {
		id: 'jira-nin-list-merge-modal-onboarding-v2.spotlight.filter',
		defaultMessage: 'One place to search work and filter results to find what you need.',
		description: 'Message for filter bar on Issue Table',
	},
	dismissButton: {
		id: 'jira-nin-list-merge-modal-onboarding-v2.spotlight.dismiss',
		defaultMessage: 'Dismiss',
		description: 'Dismiss button for the list merge spotlight',
	},
	nextButton: {
		id: 'jira-nin-list-merge-modal-onboarding-v2.spotlight.next',
		defaultMessage: 'Next',
		description: 'Next button for the list merge spotlight',
	},
	moreActionsSpotlightMessage: {
		id: 'jira-nin-list-merge-modal-onboarding-v2.spotlight.more-actions',
		defaultMessage:
			'Dive deeper - view work items as a chart, use format rules to highlight key work, and more.',
		description: 'Message for more actions button on Issue Table',
	},
	okButton: {
		id: 'jira-nin-list-merge-modal-onboarding-v2.spotlight.ok',
		defaultMessage: 'OK',
		description: 'OK button for the list merge spotlight',
	},
	listMergeSpotlightHeading: {
		id: 'jira-nin-list-merge-modal-onboarding-v2.spotlight.heading',
		defaultMessage: "We've merged List and All Work views",
		description: 'Heading for the list merge spotlight',
	},
	listMergeSpotlightBody: {
		id: 'jira-nin-list-merge-modal-onboarding-v2.spotlight.body',
		defaultMessage:
			"We've merged the best of List and All Work into a faster, accessible experience. A new List view.",
		description: 'Body for the list merge spotlight',
	},
	exploreListViewButtonLabel: {
		id: 'jira-nin-list-merge-modal-onboarding-v2.spotlight.explore-list-view-button-label',
		defaultMessage: 'Explore List view',
		description: 'Explore List View button for the list merge spotlight',
	},
	listMergeSpotlightDismiss: {
		id: 'jira-nin-list-merge-modal-onboarding-v2.spotlight.dismiss',
		defaultMessage: 'Dismiss',
		description: 'Dismiss button for the list merge spotlight',
	},
	listMergeSpotlightTellMeMoreAriaLabel: {
		id: 'jira-nin-list-merge-modal-onboarding-v2.spotlight.tell-me-more-aria-label',
		defaultMessage: 'Read our community post about the merge of List and All Work views',
		description: 'Aria label for the tell me more button for the list merge spotlight',
	},
	heading: {
		id: 'jira-nin-list-merge-modal-onboarding-v2.heading',
		defaultMessage: "We've merged List and All Work",
		description: 'Heading for the list merge modal onboarding modal',
	},
	description: {
		id: 'jira-nin-list-merge-modal-onboarding-v2.description',
		defaultMessage:
			"We've merged the best of List and All Work into a faster, accessible experience. A new List view.",
		description: 'Description for the list merge modal onboarding modal',
	},
	learnMoreLink: {
		id: 'jira-nin-list-merge-modal-onboarding-v2.learnMoreLink',
		defaultMessage: 'Read our community post about the merge of List and All Work views',
		description: 'Link to learn more about the list merge modal onboarding modal',
	},

	closeButton: {
		id: 'jira-nin-list-merge-modal-onboarding-v2.closeButton',
		defaultMessage: 'Close',
		description: 'Label for the close button in the list merge modal onboarding modal',
	},
	filtersAndGroupsDescription: {
		id: 'jira-nin-list-merge-modal-onboarding-v2.filtersAndGroupsDescription',
		defaultMessage: 'Any existing filters and groups will be applied.',
		description: 'Description for the filters and groups in the list merge modal onboarding modal',
	},
	copyListSettingsYes: {
		id: 'jira-nin-list-merge-modal-onboarding-v2.copyListSettingsYes',
		defaultMessage: 'Yes',
		description: 'Label for the yes button in the list merge modal onboarding modal',
	},
	copyListSettingsNo: {
		id: 'jira-nin-list-merge-modal-onboarding-v2.copyListSettingsNo',
		defaultMessage: 'No',
		description: 'Label for the no button in the list merge modal onboarding modal',
	},
	copyListSettingsDescription: {
		id: 'jira-nin-list-merge-modal-onboarding-v2.copyListSettingsDescription',
		defaultMessage:
			'Want us to apply your current filter and group settings to this new List view?',
		description: 'Description to allow user to choose to copy list settings to new List view',
	},
});
